// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxInput_checkbox__TfQpe","checkbox__input":"CheckboxInput_checkbox__input__iMtGj","checkbox__label":"CheckboxInput_checkbox__label__kCkUg"};